import { gql } from 'graphql-request';

export const FETCH_UP_NEXT_EPISODES = gql`
  query ($filter: UpNextEpisodeFilter!) {
    upNextEpisodes(filter: $filter) {
      id
      title
      originalTitle
      image {
        list
        cover
        listClean
        appCover
        square
        portrait
      }
      genres {
        id
        value
      }
      slug
      contents {
        ... on Episode {
          id
          title
          originalTitle
          duration
          contentOwner
          businessType
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
            listClean
            appCover
            square
            portrait
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
          tags
          introStartTime
          introEndTime
          episodeNumber
          billingType
          tier
          seoTitle
          slug
          webUrl
          rating
          releaseDate
          video {
            url
            drmKey
            hlsUrl
            isDrm
          }
          tvShow {
            id
            title
            assetSubType
            originalTitle
          }
        }
      }
      page
      totalResults
    }
  }
`;
